import React, { useState, useEffect, useContext, SyntheticEvent } from "react";
import api from "../../../../../../services/api";
import EmpresaContext from "../../../../../../contexts/Empresa";
import { ApiAccess } from "../../../../../../entities/Security";
//@ts-ignore
import { CopyToClipboard } from "react-copy-to-clipboard";

import {
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Row,
  UncontrolledTooltip,
  Badge,
  Spinner,
} from "reactstrap";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select2 from "react-select2-wrapper";

const PaginaWeb: React.FC = ({ props }: any) => {
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [apiAccess, setApiAccess] = useState<ApiAccess>({} as ApiAccess);
  const [tokens, setTokens] = useState<any[]>([]);
  const [textCopiar, setTextCopiar] = useState("Copiar token");
  const [showModal, setShowModal] = useState(false);
  const [tokenName, setTokenName] = useState("");
  const [permissions, setPermissions] = useState<any[]>([]);
  const [editingTokenId, setEditingTokenId] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [alert, setAlert] = useState<any>(null);

  const badgeColorMap = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "light",
    "info",
    "primary",
    "secondary",
  ];

  useEffect(() => {
    if (empresaSelecionada && empresaSelecionada.id) loadApiAccess();
    if (empresaSelecionada && empresaSelecionada.id) loadTokens();
  }, []);

  const handleModalChange = () => {
    setShowModal((prev) => !prev);
  };

  function handleClose() {
    setTokenName("");
    setPermissions([]);
    setEditingTokenId(null);
    handleModalChange();
  }

  async function loadApiAccess() {
    try {
      const response = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/api-access`,
      );
      setApiAccess(response?.data);
    } catch (error) {
      console.log(error);
    }
  }

  async function loadTokens() {
    try {
      const response = await api.get(`/v2/tokens`);
      setTokens(response?.data);
    } catch (error) {
      console.log(error);
    }
  }

  function handleMultipleSelect(target: any, state: any) {
    const array = Array.from(target.selectedOptions);
    state(array.map((item: any) => item.value));
  }

  async function handleCreateTokenIntegration() {
    try {
      setIsLoading(true);

      const response = await api.post(`v2/tokens`, {
        title: tokenName,
        scope: permissions,
      });

      handleClose();
      setIsLoading(false);

      setAlert(
        <ReactBSAlert
          success
          style={{ display: "block" }}
          title="Sucesso!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          {response.data.message}
        </ReactBSAlert>,
      );

      loadTokens();
    } catch (error) {
      handleClose();
      setIsLoading(false);

      setAlert(
        <ReactBSAlert
          error
          style={{ display: "block" }}
          title="Falha!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          Não foi possível criar novo token!
        </ReactBSAlert>,
      );

      console.log(error);
    }
  }

  const permissionsMap = [
    { id: 1, nome: "create-oportunity" },
    { id: 2, nome: "edit-oportunity" },
    { id: 3, nome: "get-card" },
    { id: 4, nome: "create-card" },
    { id: 5, nome: "edit-card" },
    { id: 6, nome: "move-card" },
  ];

  function handleEditToken(item: any) {
    setTokenName(item.valor);
    const selectedPermissions = item.permissoes.map((p: any) => {
      const match = permissionsMap.find((mapItem) => mapItem.nome === p.nome);
      return match ? String(match.id) : null;
    }).filter(Boolean);
    
    setPermissions(selectedPermissions);
    setEditingTokenId(item.id);
    setShowModal(true);
  }

  async function handleUpdateTokenIntegration() {
    try {
      setIsLoading(true);

      const response = await api.put(`v2/tokens/${editingTokenId}`, {
        title: tokenName,
        scope: permissions,
      });

      handleClose();
      setIsLoading(false);

      setAlert(
        <ReactBSAlert
          success
          style={{ display: "block" }}
          title="Sucesso!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          {response.data.message}
        </ReactBSAlert>,
      );

      loadTokens();
    } catch (error) {
      handleClose();
      setIsLoading(false);

      setAlert(
        <ReactBSAlert
          error
          style={{ display: "block" }}
          title="Falha!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          Não foi possível atualizar token!
        </ReactBSAlert>,
      );

      console.log(error);
    }
  }

  const deleteToken = async (id: number) => {
    try {
      setIsLoading(true);

      await api.delete(`v2/tokens/${id}`);

      loadTokens();
      setIsLoading(false);

      setAlert(
        <ReactBSAlert
          success
          style={{ display: "block" }}
          title="Sucesso!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          Token removido com sucesso!
        </ReactBSAlert>,
      );
    } catch (err) {
      setIsLoading(false);

      setAlert(
        <ReactBSAlert
          error
          style={{ display: "block" }}
          title="Falha!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          Não foi possível remover token!
        </ReactBSAlert>,
      );

      console.log(err);
    }
  };

  function handleDeleteToken(id: number) {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block" }}
        title="Tem certeza que deseja remover a token?"
        onConfirm={() => deleteToken(id)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="danger"
        confirmBtnText="Sim"
        btnSize=""
        showCancel
        focusCancelBtn
      />,
    );
  }

  return (
    <>
      <style>{`
        .select2-results__option[aria-selected="true"] {
          display: none !important;
        }
      `}</style>
      {alert}
      <Row className="justify-content-center">
        <Col lg={10} md={10}>
          <div
            style={{
              display: "flex",
              flex: 1,
              alignItems: "end",
            }}
          >
            <h2>Token Clássico</h2>
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col lg={10} md={10}>
          <FormGroup>
            <label
              className="form-control-label"
              htmlFor="example-number-input"
            >
              Token
            </label>
            <InputGroup>
              <Input
                className="form-control"
                placeholder=""
                type="text"
                value={apiAccess?.token}
                // @ts-ignore
                disabled={true}
              />
              <InputGroupAddon addonType="append">
                <CopyToClipboard
                  text={apiAccess?.token}
                  onCopy={() => setTextCopiar("Copiado")}
                >
                  <Button
                    className="btn-icon-clipboard"
                    id="tooltip982655500"
                    type="button"
                    style={{
                      padding: "8px",
                      margin: "0",
                    }}
                  >
                    <div>
                      <i className="fas fa-copy" />
                    </div>
                  </Button>
                </CopyToClipboard>
                <UncontrolledTooltip
                  delay={0}
                  trigger="hover focus"
                  target="tooltip982655500"
                >
                  {textCopiar}
                </UncontrolledTooltip>
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>
        </Col>
      </Row>

      {/* Novos tokens */}
      <Row className="justify-content-center">
        <Col lg={10} md={10}>
          <div
            style={{
              display: "flex",
              flex: 1,
              alignItems: "end",
            }}
          >
            <h2>Tokens</h2>
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col lg={10} md={10}>
          {tokens.map((item) => {
            return (
              <FormGroup key={item.id}>
                <span>
                  <label
                    className="form-control-label"
                    htmlFor="example-number-input"
                  >
                    {item.valor}
                  </label>
                  <Button
                    id={"TooltipEdit-" + item.id}
                    className="btn-sm ml-2"
                    color="primary"
                    onClick={(e) => {
                      handleEditToken(item);
                    }}
                  >
                    <i className="fas fa-edit" style={{ margin: "0" }}></i>
                  </Button>
                  <UncontrolledTooltip
                    placement="top"
                    target={"TooltipEdit-" + item.id}
                  >
                    Editar {item.valor}
                  </UncontrolledTooltip>
                  <Button
                    id={"Tooltip-2" + item.id}
                    className="btn-sm ml-2"
                    color="danger"
                    onClick={(e) => {
                      handleDeleteToken(item.id);
                    }}
                  >
                    <i className="fas fa-trash" style={{ margin: "0" }}></i>
                    <Spinner
                      style={{ marginLeft: "4px" }}
                      hidden={!isLoading}
                      className="mr-2"
                      color="light"
                      size="sm"
                    />
                  </Button>

                  <UncontrolledTooltip
                    placement="left-end"
                    target={"Tooltip-2" + item.id}
                  >
                    Clique para remover {item.valor}
                  </UncontrolledTooltip>
                </span>
                <InputGroup className="mt-2">
                  <Input
                    className="form-control"
                    placeholder=""
                    type="text"
                    value={item.tokens[0]?.token}
                    // @ts-ignore
                    disabled={true}
                  />
                  <InputGroupAddon addonType="append">
                    <CopyToClipboard
                      text={item.tokens[0]?.token}
                      onCopy={() => setTextCopiar("Copiado")}
                    >
                      <Button
                        className="btn-icon-clipboard"
                        id={`tooltip${item.id}`}
                        type="button"
                        style={{
                          padding: "8px",
                          margin: "0",
                        }}
                      >
                        <div>
                          <i className="fas fa-copy" />
                        </div>
                      </Button>
                    </CopyToClipboard>
                    <UncontrolledTooltip
                      delay={0}
                      trigger="hover focus"
                      target={`tooltip${item.id}`}
                    >
                      {textCopiar}
                    </UncontrolledTooltip>
                  </InputGroupAddon>
                </InputGroup>
                <div className="flex" style={{ gap: "8px", marginTop: "8px" }}>
                  {item.permissoes.map((permissao: any) => {
                    return (
                      <Badge
                        color={badgeColorMap[(permissao.id % 10) - 1]}
                        key={permissao.id}
                      >
                        {permissao.nome}
                      </Badge>
                    );
                  })}
                </div>
              </FormGroup>
            );
          })}
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col lg={10} md={10} className="d-flex justify-content-center">
          <Button color="primary" onClick={handleModalChange}>
            Criar Novo Token
          </Button>
        </Col>
      </Row>

      <>
        {alert}
        <Modal isOpen={showModal} toggle={handleClose}>
          <ModalHeader>{editingTokenId ? "Editar Token de Integração" : "Novo Token de Integração"}</ModalHeader>
          <ModalBody style={{ padding: "0 1.5rem" }}>
            <FormGroup>
              <label
                className="form-control-label"
                htmlFor="example-number-input"
              >
                Nome do Token
              </label>
              <InputGroup className="input-group-alternative">
                <Input
                  id="valor"
                  type="text"
                  className="form-control"
                  style={{ width: "100%", borderRadius: "0.25rem" }}
                  value={tokenName}
                  onChange={(e: SyntheticEvent) => {
                    setTokenName((e.target as HTMLInputElement).value);
                  }}
                />
              </InputGroup>
              <label
                className="form-control-label mt-3"
                htmlFor="example-number-input"
              >
                Permissões
              </label>
              <InputGroup className="input-group-alternative">
                <Select2
                  multiple
                  onSelect={({ target }) =>
                    handleMultipleSelect(target, setPermissions)
                  }
                  onUnselect={({ target }) =>
                    handleMultipleSelect(target, setPermissions)
                  }
                  options={{
                    placeholder: "Selecione as Permissões...",
                  }}
                  value={permissions}
                  data={[
                    { id: 1, nome: "Criar Oportunidade" },
                    { id: 2, nome: "Editar Oportunidade" },
                    { id: 3, nome: "Visualizar Card" },
                    { id: 4, nome: "Criar Card" },
                    { id: 5, nome: "Editar Card" },
                    { id: 6, nome: "Mover Card" },
                  ].map((item) => ({
                    id: item.id,
                    text: item.nome,
                  }))}
                />
              </InputGroup>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button
              color="primary"
              onClick={() => {
                editingTokenId ? handleUpdateTokenIntegration() : handleCreateTokenIntegration();
              }}
            >
              {editingTokenId ? "Salvar" : "Integrar"}
              <Spinner
                style={{ marginLeft: "4px" }}
                hidden={!isLoading}
                className="mr-2"
                color="light"
                size="sm"
              />
            </Button>
          </ModalFooter>
        </Modal>
      </>
    </>
  );
};

export default PaginaWeb;
